import { NgModule } from '@angular/core';
import { NbCardModule, NbIconModule, NbInputModule, NbToggleModule, NbActionsModule, NbSpinnerModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { ThemeModule } from '../../@theme/theme.module';
import { routedComponents, MetiersRoutingModule } from './metiers-routing.module';
import { FormsModule } from '@angular/forms';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { EditMetierComponent } from './edit-metiers/edit-metier.component';
import { CKEditorModule } from 'ngx-ckeditor';


@NgModule({
  imports: [
    NbCardModule,
    NbIconModule,
    NbInputModule,
    ThemeModule,
    MetiersRoutingModule,
    Ng2SmartTableModule,
    FormsModule,
    NbToggleModule,
    NgbModule,
    NgMultiSelectDropDownModule, 
    NbActionsModule,
    NbSpinnerModule,
    CKEditorModule,
  ],
  entryComponents: [
    EditMetierComponent,
  ],
  declarations: [
    EditMetierComponent,
    ...routedComponents,
  ],
})
export class MetiersModule { }
